<template>
    <v-menu
        :close-on-content-click="false"
        :nudge-width="250"
        offset-x
        left
        >
      	<template v-slot:activator="{ on }">
			<v-btn v-on="on" icon>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<span v-on="on">
							<v-icon :color="allSelected ? 'primary darken' : ''">view_column</v-icon>
						</span>
					</template>
					<span>Seleziona Colonne</span>
				</v-tooltip>
			</v-btn>
      	</template>
        <v-card>
            <v-subheader class="background-2">Scegli le colonne da visualizzare</v-subheader>
            <v-list class="background-2 pt-0" style="max-height: 350px; overflow-y: auto;" dense>
                <v-list-item v-for="(column, c) in columns" :key="c" @click.stop.prevent="toggleColumn(c)">
					<v-list-item-action>
						<v-icon v-if="columns[c]['hide']" color="primary">check_box</v-icon>
						<v-icon v-else >check_box_outline_blank</v-icon>
					</v-list-item-action>
					<v-list-item-title>{{ column['text'] }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-card>
    </v-menu>
</template>

<script>
import Vue from 'vue'

export default {
	name: 'columns-selector',
	components: {},
        
	props: {
		columns: Array,
		modelDef: String,
	},

	data() {
		return {
			message: false,
			open: true,
			canWatch: false,
		}
	},

	computed: {
		allSelected() {
			let result = this.columns.filter((column) => {
				return column.hide === false 
			})
			return result.length > 0 ? true : false
		}
	},
        
	watch: {
		columns: {
			handler(newValue, oldValue) {
				if(this.canWatch) {
					localStorage.setItem('crud_colums_selected_' + this.modelDef, JSON.stringify(newValue))
				}
			},
			deep: true,
		},
	},

	methods: {
		toggleColumn(c) {
			// Vue.set: il flag potrebbe non essere reattivo (array rimpiazzato
			// dopo il created, es. refresh della -info) e l'assegnazione
			// diretta non aggiornerebbe la UI
			Vue.set(this.columns[c], 'hide', !this.columns[c]['hide'])
		},
	},

	created() {
		if(localStorage.getItem('crud_colums_selected_'+this.modelDef) == null || JSON.parse(localStorage.getItem('crud_colums_selected_' + this.modelDef)).length == 0 ) {
			_.forEach(this.columns, (value, key) => {
				Vue.set(this.columns[key], 'hide', true)
			})
			localStorage.setItem('crud_colums_selected_' + this.modelDef, JSON.stringify(this.columns))
		} else {
			let cacheColumns = JSON.parse(localStorage.getItem('crud_colums_selected_' + this.modelDef))

			_.forEach(this.columns, (column, k) => {
				let val = _.find(cacheColumns, (cacheColumn) => {
					return cacheColumn.value == column.value
				})
				if(val) {
					// Selezione salvata senza flag (cache corrotta da versioni
					// precedenti): la colonna torna visibile, non sparita
					Vue.set(this.columns[k], 'hide', typeof val['hide'] !== 'undefined' ? val['hide'] : true)
				} else {
					Vue.set(this.columns[k], 'hide', false)
				}
			})
			// Guardia: nessuna colonna visibile e' sempre uno stato errato
			if(!this.columns.some(column => column.hide === true)) {
				_.forEach(this.columns, (value, key) => {
					Vue.set(this.columns[key], 'hide', true)
				})
			}
			localStorage.setItem('crud_colums_selected_' + this.modelDef, JSON.stringify(this.columns))
		}
		this.canWatch = true
	}
}
</script>

<style>

</style>
